import { useCallback } from 'react';
import { useSearchParams } from 'react-router';

import { queryStringContaining } from '@jane/bloom/utils/queryParams/preservingQueryParams';
import { DRAFT_QUERY_KEY } from '@jane/bloom/utils/queryParams/queryParams';
import { withoutInitialSlashes } from '@jane/bloom/utils/strings/withoutInitialSlashes';

/**
 * Provides a function that builds a url, including the query params that persist across pages.
 */
export const useFullDestination = () => {
  const [searchParams] = useSearchParams();

  return useCallback(
    (to: string) => {
      const queryParams = queryStringContaining({
        paramKeys: [DRAFT_QUERY_KEY],
        prefix: to.includes('?') ? '&' : '?',
        searchParams,
      });

      return `/${withoutInitialSlashes(to)}${queryParams}`;
    },
    [searchParams]
  );
};
